import { useMemo } from 'react';

const NO_ERRORS = {};

// The design marks an empty required dimension with the field's error state
// (red underline) but does not render a helper-text message. `useErrors`
// derives both `hasError` and `helperText` from this value, so we flag the
// cell with `true`: it is truthy (so the field renders as errored) but renders
// no visible text when passed through as the helper text.
const ERROR_MARKER = true;

export const buildDimensionRequiredErrors = ({
  selectedDimensions,
  projectRates
}) => {
  const dimensionErrors = {};

  projectRates.forEach((rate, index) => {
    selectedDimensions.forEach(dimension => {
      const cell = rate[dimension.id];

      if (cell && !cell.value) {
        dimensionErrors[dimension.id] = {
          ...dimensionErrors[dimension.id],
          [index]: ERROR_MARKER
        };
      }
    });
  });

  return dimensionErrors;
};

export const useProjectCostOverrideErrors = ({
  selectedDimensions,
  projectRates
}) =>
  useMemo(() => {
    const dimensionErrors = buildDimensionRequiredErrors({
      selectedDimensions,
      projectRates
    });

    const hasErrors = Object.keys(dimensionErrors).length > 0;

    return {
      errors: hasErrors ? { projectRates: dimensionErrors } : NO_ERRORS,
      hasErrors
    };
  }, [selectedDimensions, projectRates]);

export default useProjectCostOverrideErrors;
